// SeoPageButton.js - Button to generate SEO page from current guide
import React from 'react';
import { Globe } from 'lucide-react';
import { downloadSeoPage } from '../services/SeoPageGenerator';
import toast from 'react-hot-toast';

const SeoPageButton = ({ itinerary, className = '' }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleGenerateSeoPage = async () => {
    if (!itinerary || !itinerary.metadata?.name) {
      toast.error('Please create a guide first before generating an SEO page.');
      return;
    }

    if (!itinerary.points || itinerary.points.length === 0) {
      toast.error('Please add at least one stop to the guide before generating an SEO page.');
      return;
    }

    setIsLoading(true);
    try {
      const filename = await downloadSeoPage(itinerary);
      toast.success(`SEO package downloaded: ${filename}`);
    } catch (error) {
      console.error('Error generating SEO page:', error);
      toast.error('Failed to generate SEO page. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleGenerateSeoPage}
      disabled={isLoading}
      className={`
        px-4 py-2 rounded-lg flex items-center gap-2 transition-colors font-medium
        ${isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-teal-500 text-white hover:bg-teal-600'}
        ${className}
      `}
      title={isLoading ? 'Generating SEO package...' : 'Generate SEO-optimized page with media'}
    >
      <Globe className="w-4 h-4" />
      {isLoading ? 'Generating...' : 'Generate SEO Page'}
    </button>
  );
};

export default SeoPageButton;
